import View from '@shared/components/layout-default/layout-default-router-view';

const voice = [
  {
    path: 'voice',
    component: View,
    children: [
      {
        path: '',
        name: 'voice.index',
        redirect: {
          name: 'voice.trunk.index'
        }
      },

      {
        path: 'sip-trunks',
        name: 'voice.trunk.index',
        component: () =>
          import(
            /* webpackChunkName: 'voice' */
            '@voice/pages/trunks-list-page'
          ),
        meta: {
          title: {
            code: 'voice.breadcrumb.trunk.index'
          }
        }
      },

      {
        path: 'stats',
        component: View,
        children: [
          {
            path: '',
            name: 'voice.stats.index',
            redirect: {
              name: 'voice.stats.type',
              params: {
                type: 'general'
              }
            }
          },
          {
            path: ':type(general|detailed)',
            name: 'voice.stats.type',
            component: () =>
              import(
                /* webpackChunkName: 'mailer-mailings' */
                '@voice/pages/voice-stats-page'
              ),
            meta: {
              title: {
                code: 'shared.breadcrumb.stats.title'
              }
            }
          }
        ]
      }
    ]
  }
];
export { voice };
